import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/kit";
import SignIn from "@/pages/SignIn";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import CreateOrg from "@/pages/CreateOrg";
import DownloadPage from "@/pages/DownloadPage";
import Projects from "@/condoor/Projects";
import Workspace from "@/condoor/Workspace";

// The Phase 1–5 workflow pages (MyWork, ProjectLayout, PackageWorkspace, DocumentsContext, TeamSettings,
// InviteAccept, JoinOrg) are no longer routed; their files stay in the repo.

function RequireAuth({ children, needsOrg = true }) {
  const { me } = useAuth();
  const location = useLocation();
  if (me === undefined) return <Spinner />;
  if (!me) return <Navigate to={`/signin?next=${encodeURIComponent(location.pathname)}`} replace />;
  if (needsOrg && !me.demo && me.orgs.length === 0) return <Navigate to="/setup/organization" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/download" element={<DownloadPage />} />
      <Route path="/signin" element={<SignInGate />} />
      <Route path="/setup/organization" element={<RequireAuth needsOrg={false}><CreateOrg /></RequireAuth>} />
      <Route path="/projects" element={<RequireAuth><Projects /></RequireAuth>} />
      <Route path="/p/:pid" element={<RequireAuth><Workspace /></RequireAuth>} />
      {/* The architect's invite link: no account, no catalog, no prices. */}
      <Route path="/a/:token" element={<Workspace architect />} />
      <Route path="*" element={<CatchAll />} />
    </Routes>
  );
}

function CatchAll() {
  const { me } = useAuth();
  if (me === undefined) return <Spinner />;
  return <Navigate to={me ? "/projects" : "/"} replace />;
}

function SignInGate() {
  const { me } = useAuth();
  if (me === undefined) return <Spinner />;
  return <SignIn />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="bottom-right" richColors closeButton />
      </BrowserRouter>
    </AuthProvider>
  );
}
